/*
*	provides validation using 4imprint styling rules and adds accessibility attributes
*	the html document needs to have a heading with a "formHeading" class to insert the error summary after

	PARAMS:
		formId - id of the container to look for inputs to validate
		callBack - function to execute if validation passes
		e - event object
	USAGE:
		var registerForm = new forms4i();
		document.getElementById('btnSubmit').addEventListener("click", function (e) {
			e.preventDefault(); --> This may not be necessary depending on the form
			registerForm.formValidation(document.getElementById("RegistrationForm"), formSuccess(), e);
		});
*/

var forms4i = function () {
    "use strict";

    var closest = function (el, fn) {
            return el && (fn(el) ? el : closest(el.parentNode, fn));
        },

        bindPasswordButtons = function () {
            var togglePass = document.getElementsByClassName("toggle-password");
            if (togglePass.length > 0) {
                var toggleThis = function (e) {
                    e.preventDefault();
                    var el = e.currentTarget;
                    var inputId = el.getAttribute("toggle");
                    if (document.getElementById(inputId).getAttribute("type") === "password") {
                        document.getElementById(inputId).setAttribute("type", "text");
                        el.setAttribute("aria-label", "Hide Password");
                        el.setAttribute("title", "Hide Password");
                        el.setAttribute("aria-pressed", "true");
                    } else {
                        document.getElementById(inputId).setAttribute("type", "password");
                        el.setAttribute("aria-label", "Show Password");
                        el.setAttribute("title", "Show Password");
                        el.setAttribute("aria-pressed", "false");
                    }
                };

                for (var i = 0; i < togglePass.length; i++) {
                    togglePass[i].removeEventListener("click", toggleThis);
                    togglePass[i].addEventListener("click", toggleThis);
                }
            }
        },

        clearValidation = function () {
            if (document.getElementById("ErrorBox")) {
                document.getElementById("ErrorBox").parentNode.removeChild(document.getElementById("ErrorBox"));
            }
            var invalidFields = [].slice.call(document.getElementsByClassName("input-validation-error"));
            invalidFields.forEach(function (el, index, array) {
                el.classList.remove("input-validation-error");
                el.setAttribute("aria-invalid", "false");
                el.parentNode.querySelector(".errorMessage").innerHTML = "";
                el.parentNode.querySelector(".errorMessage").classList.add("hide");
            });
        },

        isCardNumber = function (cardnum, rules, validLengths) {
            var cardnumber = cardnum;
            for (var n = 0; n < validLengths.length; n++)
                if (cardnumber.toString().length == validLengths[n]) {
                    for (var m = 0; m < rules.length; m++) {
                        var headdigit = cardnumber.substring(0, rules[m].toString().length);
                        if (headdigit == rules[m])
                            return true;
                    }
                    return false;
                }
            return false;
        },

        isValidCardNumber = function (el) {
            var cardnum = el.value;
            if (cardnum.indexOf("****") != -1) { // saved card already, in edit mode so no need to recheck validity
                return true;
            }
            switch (cardnum.substring(0, 1)) {
                case "3":
                    return isCardNumber(cardnum, [34, 37], [15]);
                case "4":
                    return isCardNumber(cardnum, [4], [13, 16]);
                case "2":
                case "5":
                    return isCardNumber(cardnum, [51, 52, 53, 54, 55, 22, 23, 24, 25, 26, 27], [16]);
                case "6":
                    return isCardNumber(cardnum, [6011], [16]);
                default:
                    return false;
            }
        },

        fadeCCImgs = function (cardNumElem, btnElem, savedNameElem) {
            switch (cardNumElem.value.substring(0, 1)) {
                case "3": //ae
                    if (document.getElementById('aeccimg')) {
                        if (document.getElementById('aeccimg')) {
                            document.getElementById('aeccimg').setAttribute("alt", "American Express");
                        }
                        if (document.getElementById('mcccimg')) {
                            document.getElementById('mcccimg').setAttribute("alt", "Mastercard");
                        }
                        if (document.getElementById('visaccimg')) {
                            document.getElementById('visaccimg').setAttribute("alt", "Visa");
                        }
                        if (document.getElementById('discccimg')) {
                            document.getElementById('discccimg').setAttribute("alt", "Discover");
                        }
                        cardAccepted("American Express", cardNumElem, btnElem, savedNameElem);
                    } else {
                        cardNotAccepted("American Express", cardNumElem, btnElem);
                    }
                    break;
                case "4": //visa
                    if (document.getElementById('visaccimg')) {
                        if (document.getElementById('aeccimg')) {
                            document.getElementById('aeccimg').setAttribute("alt", "American Express");
                        }
                        if (document.getElementById('mcccimg')) {
                            document.getElementById('mcccimg').setAttribute("alt", "Mastercard");
                        }
                        if (document.getElementById('visaccimg')) {
                            document.getElementById('visaccimg').setAttribute("alt", "Visa");
                        }
                        if (document.getElementById('discccimg')) {
                            document.getElementById('discccimg').setAttribute("alt", "Discover");
                        }
                        cardAccepted("Visa", cardNumElem, btnElem, savedNameElem);
                    } else {
                        cardNotAccepted("Visa", cardNumElem, btnElem);
                    }
                    break;
                case "2":
                case "5": //mc
                    if (document.getElementById('mcccimg')) {
                        if (document.getElementById('aeccimg')) {
                            document.getElementById('aeccimg').setAttribute("alt", "American Express");
                        }
                        if (document.getElementById('mcccimg')) {
                            document.getElementById('mcccimg').setAttribute("alt", "Mastercard");
                        }
                        if (document.getElementById('visaccimg')) {
                            document.getElementById('visaccimg').setAttribute("alt", "Visa");
                        }
                        if (document.getElementById('discccimg')) {
                            document.getElementById('discccimg').setAttribute("alt", "Discover");
                        }
                        cardAccepted("MasterCard", cardNumElem, btnElem, savedNameElem);
                    } else {
                        cardNotAccepted("MasterCard", cardNumElem, btnElem);
                    }
                    break;
                case "6": //discover
                    if (document.getElementById('discccimg')) {
                        if (document.getElementById('aeccimg')) {
                            document.getElementById('aeccimg').setAttribute("alt", "American Express");
                        }
                        if (document.getElementById('mcccimg')) {
                            document.getElementById('mcccimg').setAttribute("alt", "Mastercard");
                        }
                        if (document.getElementById('visaccimg')) {
                            document.getElementById('visaccimg').setAttribute("alt", "Visa");
                        }
                        if (document.getElementById('discccimg')) {
                            document.getElementById('discccimg').setAttribute("alt", "Discover");
                        }
                        cardAccepted("Discover", cardNumElem, btnElem, savedNameElem);
                    } else {
                        cardNotAccepted("Discover", cardNumElem, btnElem);
                    }
                    break;
                case "":
                    if (document.getElementById('aeccimg')) {
                        document.getElementById('aeccimg').setAttribute("alt", "American Express");
                    }
                    if (document.getElementById('mcccimg')) {
                        document.getElementById('mcccimg').setAttribute("alt", "Mastercard");
                    }
                    if (document.getElementById('visaccimg')) {
                        document.getElementById('visaccimg').setAttribute("alt", "Visa");
                    }
                    if (document.getElementById('discccimg')) {
                        document.getElementById('discccimg').setAttribute("alt", "Discover");
                    }
                    cardAccepted(null, cardNumElem, btnElem, savedNameElem);
                    break;
                default:
                    if (document.getElementById('aeccimg')) {
                        document.getElementById('aeccimg').setAttribute("alt", "American Express");
                    }
                    if (document.getElementById('mcccimg')) {
                        document.getElementById('mcccimg').setAttribute("alt", "Mastercard");
                    }
                    if (document.getElementById('visaccimg')) {
                        document.getElementById('visaccimg').setAttribute("alt", "Visa");
                    }
                    if (document.getElementById('discccimg')) {
                        document.getElementById('discccimg').setAttribute("alt", "Discover");
                    }
                    cardNotAccepted(null, cardNumElem, btnElem);
                    break;
            }
        },

        cardNotAccepted = function (cardName, cardNumElem, btnElem) {
            //btnElem.disabled = true;
            cardNumElem.classList.add("input-validation-error");
            cardNumElem.setAttribute("aria-invalid", "true");
            var errorMsg;
            if (cardName) {
                errorMsg = cardNumElem.parentNode.querySelector(".errorMessage");
                errorMsg.textContent = "We do not accept " + cardName + ".";
            } else {
                errorMsg = cardNumElem.parentNode.querySelector(".errorMessage");
                errorMsg.textContent = "This does not appear to be a valid card number.";
            }
            cardNumElem.parentNode.querySelector(".errorMessage").classList.remove("hide");
        },

        cardAccepted = function (cardName, cardNumElem, btnElem, savedNameElem) {
            //btnElem.removeAttribute("disabled");
            cardNumElem.classList.remove("input-validation-error");
            cardNumElem.setAttribute("aria-invalid", "false");
            cardNumElem.parentNode.querySelector(".errorMessage").textContent = "";
            cardNumElem.parentNode.querySelector(".errorMessage").classList.add("hide");

            if (savedNameElem && !savedNameElem.value && cardName) {
                savedNameElem.value = cardName;
                return;
            }
            if (savedNameElem) {
                var savename = savedNameElem.value;
            }
            if (!cardName && savename && (savename === "American Express" || savename === "Visa" || savename === "Discover" || savename === "MasterCard")) {
                savedNameElem.value = '';
            }
        },

        showSaveCardName = function (isSavedElem, savedNameElem, isDefaultElem) {
            if (isSavedElem.checked == true) {
                if (savedNameElem.value === '.') {
                    savedNameElem.value = '';
                }
                isSavedElem.setAttribute("aria-expanded", "true");
                savedNameElem.style.display = "block";
                savedNameElem.classList.add("txtReq");
                savedNameElem.parentNode.querySelector("label").textContent = "Name this Card*";
                savedNameElem.parentNode.querySelector("label").style.display = "block";
                if (isDefaultElem) {
                    isDefaultElem.style.display = "block";
                    isDefaultElem.nextElementSibling.style.display = "block";
                }
            } else {
                isSavedElem.setAttribute("aria-expanded", "false");
                savedNameElem.style.display = "none";
                savedNameElem.value = "";
                savedNameElem.classList.remove("txtReq");
                savedNameElem.parentNode.querySelector("label").textContent = "Name this Card";
                savedNameElem.parentNode.querySelector("label").style.display = "none";
                savedNameElem.parentNode.querySelector("span").classList.add("hide");
                savedNameElem.classList.remove("input-validation-error");
                if (isDefaultElem) {
                    isDefaultElem.style.display = "none";
                    isDefaultElem.nextElementSibling.style.display = "none";
                    isDefaultElem.checked = false;
                }
            }
        },

        /*
        maskCCNumber = function (ccMaskElem, cardNumElem) {
        	var ccMask = ccMaskElem.value;
        	if (cardNumElem && ccMask != "") {
        		VMasker(cardNumElem).maskPattern(ccMask);
        	}
        },
        */

        maskCCNumber = function (ccMaskElem, cardNumElem) {
            var ccMask = ccMaskElem.value;
            if (cardNumElem && ccMask != "") {
                function inputHandler(masks, event) {
                    var input = event.target;
                    var digits = input.value.substring(0, 2);
                    var maskIndex = digits === '34' || digits === '37' ? 1 : 0;
                    VMasker(input).unMask();
                    VMasker(input).maskPattern(masks[maskIndex]);
                }
                var ccMaskArr = ccMask.split(",");
                VMasker(cardNumElem).maskPattern(ccMaskArr[0]);
                cardNumElem.addEventListener('input', inputHandler.bind(undefined, ccMaskArr), false);
            }
        },

        maskCVVNumber = function (cvvMaskElem, cardCVVElem) {
            var cvvMask = cvvMaskElem.value;
            if (cardCVVElem && cvvMask != "") {
                VMasker(cardCVVElem).maskPattern(cvvMask);
            }
        },

        unmaskCCNumber = function (cardNumElem) {
            VMasker(cardNumElem).unMask();
        },

        getPaymentTypeID = function (creditCardIds, cardNumber, currentPTID) {
            return getCreditCardId(creditCardIds, getCreditCardName(cardNumber), currentPTID);
        },

        getCreditCardName = function (cardNumber) {
            var fcDig = cardNumber.substring(0, 1);
            switch (fcDig) {
                case "3":
                    return "American Express";
                case "4":
                    return "Visa";
                case "2":
                case "5":
                    return "MasterCard";
                case "6":
                    return "Discover";
                default:
                    return "Credit Card";
            }
        },

        getCreditCardId = function (creditCardIds, creditCardName, currentPTID) {
            // credit card name needs to match name in paymenttypeid enum
            var index = creditCardIds.map(function (e) {
                return e.Name;
            }).indexOf(creditCardName.replace(/\s+/g, ""));
            return index >= 0 ? creditCardIds[index].Id : currentPTID;
        },

        maskPhoneNumber = function (phoneMaskElem, phoneNumElem) {
            var phoneNumMask = phoneMaskElem.value;
            if (phoneNumElem && phoneNumMask != "") {
                VMasker(phoneNumElem).maskPattern(phoneNumMask);
            }
        },

        formValidation = function (formId, callBack, e) {
            var panel, line,
                formValid = true,
                valid = true,
                errorMsg = "";

            var validateRequired = function (element) {
                    if (element.hasAttribute("data-val-postalcodevalidation-required")) {
                        if (element.getAttribute("data-val-postalcodevalidation-required").toLowerCase() === "true") {
                            formValid = false;
                            valid = false;
                            errorMsg = element.hasAttribute("data-val-postalcodevalidation") ? element.getAttribute("data-val-postalcodevalidation") : element.title;
                        }
                    } else if (element.hasAttribute("data-val-statevalidation-required")) {
                        if (element.getAttribute("data-val-statevalidation-required").toLowerCase() === "true") {
                            formValid = false;
                            valid = false;
                            errorMsg = element.hasAttribute("data-val-statevalidation") ? element.getAttribute("data-val-statevalidation") : element.title;
                        }
                    } else if (element.hasAttribute("data-val-companynamevalidation-required")) {
                        if (element.getAttribute("data-val-companynamevalidation-required").toLowerCase() === "true") {
                            formValid = false;
                            valid = false;
                            errorMsg = element.hasAttribute("data-val-companynamevalidation") ? element.getAttribute("data-val-companynamevalidation") : element.title;
                        }
                    } else {
                        formValid = false;
                        valid = false;
                        errorMsg = element.hasAttribute("data-val-required") ? element.getAttribute("data-val-required") : element.title;
                    }
                },

                validate = function (selector) {
                    formValid = true;
                    var list = "",
                        invalidFields = [].slice.call(selector.getElementsByClassName("input-validation-error")),
                        fieldsToValidate = [].slice.call(selector.getElementsByClassName("txtReq")),
                        allInputFields = [].slice.call(formId.querySelectorAll("input, select, textarea"));

                    allInputFields.forEach(function (el, index, array) {
                        if (!el.disabled && !el.classList.contains("txtReq") && el.type.toLowerCase() != "submit" && el.type.toLowerCase() != "hidden") {
                            if (el.tagName.toLowerCase() == "input" || el.tagName.toLowerCase() == "textarea") {
                                if (el.type.toLowerCase() != "checkbox" && el.type.toLowerCase() != "radio" && el.value.trim() != "") {
                                    fieldsToValidate.push(el);
                                }
                            } else if (el.tagName.toLowerCase() == "select" && (el.value != "0" && el.value != "")) {
                                fieldsToValidate.push(el);
                            } else if (el.tagName.toLowerCase() == "div" && (el.innerHTML == "" || el.innerHTML.indexOf("Select ") != -1)) {
                                fieldsToValidate.push(el);
                            }
                        }
                    });

                    invalidFields.forEach(function (el, index, array) {
                        el.classList.remove("input-validation-error");
                    });

                    if (document.getElementById("ErrorBox")) {
                        document.getElementById("ErrorBox").parentNode.removeChild(document.getElementById("ErrorBox")); // fix for IE11
                    }

                    var errorMessages = [].slice.call(selector.getElementsByClassName("errorMessage"));
                    errorMessages.forEach(function (el, index, array) {
                        el.classList.add("hide");
                    });

                    //Radio Button & Check Box Section
                    var requiredSelectionElems = [].slice.call(selector.querySelectorAll('.rdbReq')); // get all required radio buttons / check boxes
                    var names = [];
                    requiredSelectionElems.forEach(function (el, index, array) { // separate radio buttons and checkboxes into groups by name
                        var name = requiredSelectionElems[index].name;
                        if (names.indexOf(name) == -1) {
                            names.push(name);
                        }
                    });
                    names.forEach(function (nameEl, nameInd, array) { // check validity of each radio button and/or checkbox group
                        var complete = false;
                        var selectionElemsToValidate = [].slice.call(document.getElementsByName(names[nameInd]));
                        selectionElemsToValidate.forEach(function (selElem, index, array) {
                            valid = true;
                            if (selElem.checked) {
                                complete = true;
                            }
                        });
                        if (!complete) {
                            formValid = false;
                            valid = false;
                        }
                        var el = selectionElemsToValidate[selectionElemsToValidate.length - 1];
                        var fieldset = closest(el, function (elem) {
                            return elem.tagName.toLowerCase() === "fieldset";
                        });
                        var firstElem = selectionElemsToValidate[0];
                        if (!valid) {
                            el.classList.add("input-validation-error");
                            el.setAttribute("aria-invalid", "true");
                            fieldset.querySelector(".errorMessage").classList.remove("hide"); // testing this to see if we have our radio buttons in two columns if this will still work
                            errorMsg = fieldset.querySelector(".errorMessage").innerHTML;
                            line = '<li><a href="###ELEMENTID##" tabindex="0" role="link" class="errorItem">##ERRORMESSAGE##</a></li>';
                            list += line.replace(new RegExp("##ELEMENTID##", 'g'), firstElem.id).replace("##ERRORMESSAGE##", errorMsg);
                        } else {
                            el.classList.remove("input-validation-error");
                            if (fieldset.getElementsByClassName("errorMessage")[0]) { // testing this to see if we have our radio buttons in two columns if this will still work
                                fieldset.getElementsByClassName("errorMessage")[0].classList.add("hide");
                            }
                            el.removeAttribute("aria-invalid");
                            el.removeAttribute("tabindex");
                        }
                    });
                    // end Radio Button & Check Box Section

                    fieldsToValidate.forEach(function (el, index, array) {
                        valid = true;
                        errorMsg = "";

                        // remove any mask that may be on the value  //TODO
                        //var value = el.data().mask ? el.cleanVal() : el.value;
                        var value = el.value;
                        var innerHTML = el.innerHTML;

                        // check if there is a value
                        if (value != undefined && value.trim() === "") {
                            validateRequired(el);
                        }
                        // hack for details page 
                        else if (innerHTML != undefined && innerHTML.toLowerCase().indexOf("select") != -1 && el.getElementsByClassName("colorOptionText")[0]) {
                            if (el.getElementsByClassName("txtToValidate")[0]) {
                                //validateRequired(el.getElementsByClassName("txtToValidate")[0]);
                            } else {
                                validateRequired(el);
                            }
                        } else if ((el.pattern !== "" && value.search(el.pattern) < 0) || (el.hasAttribute("data-val-regex-pattern") && value.search(el.getAttribute("data-val-regex-pattern")) < 0)) {
                            // check if there is a reg expression
                            formValid = false;
                            valid = false;
                            errorMsg = el.hasAttribute("data-val-regex") ? el.getAttribute("data-val-regex") : el.title;
                        } else if (el.hasAttribute("data-val-length-max") && value.trim().length > parseInt(el.getAttribute("data-val-length-max"))) {
                            // check if there is a max length
                            formValid = false;
                            valid = false;
                            errorMsg = el.hasAttribute("data-val-length") ? el.getAttribute("data-val-length") : el.title;
                        } else if (el.hasAttribute("data-val-length-min") && value.trim().length < parseInt(el.getAttribute("data-val-length-min"))) {
                            // check if there is a min length
                            formValid = false;
                            valid = false;
                            errorMsg = el.hasAttribute("data-val-length") ? el.getAttribute("data-val-length") : el.title;
                        } else if (el.hasAttribute("data-val-equalto-other") && document.getElementById(el.getAttribute("data-val-equalto-other")) !== null && document.getElementById(el.getAttribute("data-val-equalto-other")).value.trim() !== value.trim()) {
                            // check if there is a comparison
                            formValid = false;
                            valid = false;
                            errorMsg = el.hasAttribute("data-val-equalto") ? el.getAttribute("data-val-equalto") : el.title;
                        } else if (el.hasAttribute("data-validate-expiry") && el.getAttribute("data-validate-expiry") && document.getElementById(el.getAttribute("data-validate-expiry")) !== null) {
                            // check if credit card expiry date
                            var year = document.getElementById(el.getAttribute("data-validate-expiry")).value;
                            var today = new Date();
                            if (year === today.getFullYear().toString().slice(-2) && parseInt(value) < today.getMonth() + 1) {
                                formValid = false;
                                valid = false;
                                errorMsg = "Please enter a valid expiration date.";
                            }
                        } else if ((el.hasAttribute("data-validate-value-cant-be-select") && el.getAttribute("data-validate-value-cant-be-select").trim().toLowerCase() === 'true')) {
                            //makes sure that an select does not have Select as its selected option
                            if (el.value.toLowerCase() === "select") {
                                formValid = false;
                                valid = false;
                                errorMsg = el.title;
                            }
                        } else if ((el.id == "PaymentMethod_CardNumber" || el.id == "CardNumber") && !isValidCardNumber(el)) {
                            formValid = false;
                            valid = false;
                            errorMsg = el.title;
                        }

                        // if input is invalid
                        if (!valid) {
                            e.preventDefault();
                            el.classList.add("input-validation-error");
                            el.setAttribute("aria-invalid", "true");
                            el.parentNode.querySelector(".errorMessage").classList.remove("hide");
                            el.parentNode.querySelector(".errorMessage").innerHTML = errorMsg;
                            line = '<li><a href="###ELEMENTID##" tabindex="0" class="errorItem">##ERRORMESSAGE##</a></li>';
                            list += line.replace(new RegExp("##ELEMENTID##", 'g'), el.id).replace("##ERRORMESSAGE##", errorMsg);
                        } else {
                            el.classList.remove("input-validation-error");
                            if (el.parentNode.getElementsByClassName("errorMessage")[0]) {
                                el.parentNode.getElementsByClassName("errorMessage")[0].classList.add("hide");
                            }
                            el.setAttribute("aria-invalid", "false");
                            el.setAttribute("tabindex", "-1");
                        }
                    });
                    // if form is invalid
                    if (!formValid) {
                        var formHeading = selector.getElementsByClassName("formHeading")[0],
                            panel = '<div id="ErrorBox" class="ErrorMsgPanel" role="alert" aria-atomic="true"><h3 id="ErrorTitle" class="validationHeading">Please correct the following errors and resubmit:</h3><ul id="ErrorMsgBox">##ERRORLINES##</ul></div>';
                        formHeading.insertAdjacentHTML('afterend', panel.replace("##ERRORLINES##", list));

                        // reorder error lines if there are required radio buttons that would put them out of order.
                        if (requiredSelectionElems.length > 0) {
                            var formElements = [].slice.call(document.querySelectorAll("form input, form textarea, form select, div input, div textarea, div select"));
                            var errorListLines = [].slice.call(document.getElementById("ErrorMsgBox").getElementsByTagName('li'));
                            var newErrorListLines = new Array();
                            errorListLines.forEach(function (elem, ind, arr) {
                                formElements.forEach(function (el, index, array) {
                                    if (el.id == elem.firstChild.hash.replace("#", "")) {
                                        newErrorListLines[formElements.indexOf(el)] = elem;
                                    }
                                });
                            });
                            var filtered = newErrorListLines.filter(function (el) {
                                return el != null;
                            });
                            var errorMsgBoxList = document.getElementById("ErrorMsgBox");
                            while (errorMsgBoxList.firstChild) {
                                errorMsgBoxList.removeChild(errorMsgBoxList.firstChild);
                            }
                            filtered.forEach(function (el, index, array) {
                                errorMsgBoxList.appendChild(el);
                            });
                        }

                        try {
                            formHeading.scrollIntoView({
                                behavior: "smooth"
                            });
                            selector.getElementsByClassName("ErrorMsgPanel")[0].getElementsByTagName("li")[0].getElementsByTagName("a")[0].focus();
                        } catch (err) {
                            selector.getElementsByClassName("ErrorMsgPanel")[0].getElementsByTagName("li")[0].getElementsByTagName("a")[0].focus();
                        }
                        // focus on appropriate input when error link in list is clicked
                        var errorListItems = [].slice.call(document.getElementsByClassName("errorItem"));
                        errorListItems.forEach(function (el, index, array) {
                            el.addEventListener("click", function (e) {
                                e.preventDefault();
                                var errorElem = document.getElementById(el.getAttribute("href").replace("#", ""));
                                errorElem.scrollIntoView({
                                    behavior: "smooth"
                                });
                                errorElem.focus();
                            });
                        });
                        return formValid;
                    } else if (typeof callBack === "function") {
                        callBack();
                    }

                };

            validate(formId);
        },

        serverValidation = function (formId) {
            var validate = function (selector) {
                try {
                    var items = [].slice.call(selector.getElementsByTagName("li")),
                        element,
                        anchorTag,
                        start = 0,
                        end = 0,
                        html = "";

                    items.forEach(function (el, index, array) {
                        html = el.innerHTML;
                        if (el.getElementsByTagName("a")[0]) {
                            anchorTag = el.getElementsByTagName("a")[0];
                        }
                        start = html.indexOf("document.getElementById");

                        if (start >= 0) {
                            end = html.indexOf(")", start);

                            if (end > start) {
                                element = eval(html.substring(start, end + 1));
                                if (element) {
                                    element.className += (element.className ? " input-validation-error" : "input-validation-error");
                                    element.setAttribute("aria-invalid", "true");
                                    element.removeAttribute("tabindex");
                                    element.parentNode.getElementsByClassName("errorMessage")[0].classList.remove("hide");
                                    if (anchorTag) {
                                        element.parentNode.getElementsByClassName("errorMessage")[0].innerHTML = anchorTag.innerHTML;
                                    }
                                }
                            }
                        }
                    });
                } catch (e) {
                    console.log(e.message);
                }
            };
            validate(formId);
        };

    bindPasswordButtons();

    return {
        formValidation: formValidation,
        serverValidation: serverValidation,
        BindPasswordButtons: bindPasswordButtons,
        FadeCCImgs: fadeCCImgs,
        MaskCCNumber: maskCCNumber,
        MaskCVVNumber: maskCVVNumber,
        UnmaskCCNumber: unmaskCCNumber,
        MaskPhoneNumber: maskPhoneNumber,
        GetPaymentTypeID: getPaymentTypeID,
        GetCreditCardName: getCreditCardName,
        GetCreditCardId: getCreditCardId,
        ShowSaveCardName: showSaveCardName,
        ClearValidation: clearValidation
    };
};